<template>
  <v-dialog v-model="dialog" :width="dialogWidth" :scrollable="true">
    <v-card>
      <v-card-title class="headline">
        <span>Veto einlegen</span>
      </v-card-title>
      <v-card-text>
        <v-container class="pa-0">
          <v-row no-gutters>
            <v-col cols="12">
              <span>{{$t('vetoDialog.description')}}</span>
              <v-radio-group v-model="reason" :disabled="loading">
                <v-radio
                  v-for="(option, key) in reasonOptions"
                  :key="key"
                  :label="option.text"
                  :value="key"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" v-if="currentOptionNotice">
              <info-block>{{currentOptionNotice}}</info-block>
            </v-col>
            <v-col cols="12" v-if="requiresMessage">
              <v-textarea
                v-model="message"
                name="input-message"
                :label="currentMessageHeadline"
                :disabled="loading"
                :rows="4"
                class=""
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" data-test-id="confirmButton" @click="sendVeto()" :disabled="!sendMessageEnabled || loading">
          <v-icon left>mdi-send</v-icon>{{$t('common.send')}}
        </v-btn>
        <v-btn color="error" data-test-id="cancelButton" text @click="close()" :disabled="loading">
          <v-icon left>mdi-close</v-icon>{{$t('common.cancel')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  MUTATION_RAISE_NOTIFICATION
} from "@/plugins/store";
import InfoBlock from "@/widgets/InfoBlock";

export default {
  name: "VetoDialog",
  components: {InfoBlock},
  props: {
    matchUid: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
  },
  data: function () {
    return {
      dialog: false,
      loading: false,
      reason: undefined,
      reasonOptions: {
        resultInverted: { text: this.$t('vetoDialog.options.result-inverted'), notice: this.$t('vetoDialog.requires-pictorial-evidence') },
        resultWrong: { text: this.$t('vetoDialog.options.result-wrong'), notice: this.$t('vetoDialog.requires-pictorial-evidence'), requiresMessage: true, messageHeadline: this.$t('vetoDialog.result-wrong-message-headline') },
        stillNoResult: { text: this.$t('vetoDialog.options.still-no-result') },
        other: { text: this.$t('vetoDialog.options.other'), requiresMessage: true, messageHeadline: this.$t('vetoDialog.message-for-admins') },
      },
      message: undefined,
    };
  },
  computed: {
    dialogWidth: function () {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "400";
      }
      return "80%";
    },
    requiresMessage: function() {
      if (!this.reason) {
        return false;
      }
      let reasonObj = this.reasonOptions[this.reason];
      if (reasonObj.requiresMessage) {
        return true
      }
      return false
    },
    currentOptionNotice: function() {
      if (!this.reason) {
        return undefined;
      }
      let reasonObj = this.reasonOptions[this.reason];
      return reasonObj.notice;
    },
    currentMessageHeadline: function() {
      if (!this.reason) {
        return undefined;
      }
      let reasonObj = this.reasonOptions[this.reason];
      return reasonObj.messageHeadline;
    },
    sendMessageEnabled: function() {
      if (this.requiresMessage) {
        let inputLen = this.message ? this.message.length : 0;
        return inputLen >= 3
      }
      return this.reason != undefined;
    }
  },
  watch: {
    visible: function (val) {
      this.dialog = val;
    },
    dialog: function (val) {
      if (val === false) {
        this.closeAction();
      }
    },
  },
  created() {},
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    sendVeto() {
      let data = {
        reasonKey: this.reason
      };
      if (this.requiresMessage) {
        data.message = this.message;
      }
      console.log('data', data)
      this.loading = true;
      this.$api.createVeto(this.matchUid, data)
      .then(() => {
        this.loading = false;
        this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
          message: this.$t('vetoDialog.success-message'),
          type: "success"
        });
        this.closeAction();
      })
      .catch(error => {
        this.loading = false;
        this.$common.onError(error)
      })
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
</style>
